import React from "react";
import { skills } from "../../helpers/data.js";
import SectionHeader from "../../components/SectionHeader";
import "./skills.scss";

const Skills = () => {
  const subtitle =
    "Some of the tools, libraries and technologies I use to build my projects.";

  return (
    <section className="skills section" id="skills">
      <div className="section-wrapper">
        <SectionHeader title="Tools." subtitle={subtitle} />
        <div className="skills-content content">
          <ul className="skills-list">
            {skills.map(({ skill, icon }) => (
              <li key={skill} className="skill">
                <span className="skill-icon">{icon}</span>
                <span className="skill-name">{skill}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Skills;
